<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" title="Volver" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button [disabled]="!habilitarGuardar" class="btn btn-outline-success" title="Nueva Com. Autónoma" *ngIf="usuarioAC.Id > 0" type="button" (click)="onAddAgenteControlCa()"><i class="fa fa-file-o"></i> Nueva Com. Autónoma </button>
            <button [disabled]="!habilitarGuardar" *ngIf="!visibilitySpinner" type="submit" title="Guardar" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Agente Control</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedEntidad = !isCollapsedEntidad"
                       [attr.aria-expanded]="!isCollapsedEntidad" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Principales
                            <i *ngIf="isCollapsedEntidad" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedEntidad" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">

                        <div class="row">

                            <!--el CAS acepta 20 y 30 caracteres para Nombre y Apellidos, de ahí el maxlength-->

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpNombre">Nombre</label>
                                <input formControlName="Nombre" name="Nombre" title=""
                                       class="form-control" id="inpNombre" type="text" value="" [ngClass]="displayFieldCss('Nombre')" maxlength="20">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Nombre','required')">
                                    Nombre es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpApellidos">Apellidos</label>
                                <input formControlName="Apellidos" name="Apellidos" title=""
                                       class="form-control" id="inpApellidos" type="text" value="" [ngClass]="displayFieldCss('Apellidos')" maxlength="30">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Apellidos','required')">
                                    Apellidos es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpNif">NIF/NIE</label>
                                <input formControlName="Nif" name="Nif" title=""
                                       class="form-control" id="inpNif" type="text" value="" [ngClass]="displayFieldCss('Nif')" maxlength="9">

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nif','required')">
                                    NIF/NIE es obligatorio
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nif','NIF')">
                                    Formato de NIF incorrecto
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nif','nif_duplicated')">
                                    El NIF ya existe en la base de datos
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpRopo">ROPO</label>
                                <input formControlName="Ropo" name="Ropo" title=""
                                       class="form-control" id="inpRopo" type="text" value="" [ngClass]="displayFieldCss('Ropo')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Ropo','required')">
                                    ROPO es obligatorio
                                </div>
                            </div>

                        </div>

                        <div class="row">

                            <!--<div class="form-group col-md-3">
        <label class="col-form-label" for="">Comunidad Autónoma</label>
        <ng-select loadingText="Cargando..."
                   [items]="listComunidad$ | async"
                   bindLabel="Descripcion"
                   bindValue="Id"
                   formControlName="IdComunidadAutonoma"
                   [loading]="!(listComunidad$ | async)"
                   notFoundText="Comunidad Autónoma no encontrada"
                   [ngClass]="displayFieldCssNgSelect('IdComunidadAutonoma')"
                   placeholder="-- Seleccione una Comunidad --"
                   clearAllText="Eliminar selección"
                   (change)="onSelectComunidad()">
        </ng-select>
        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdComunidadAutonoma','required')">
            Comunidad Autónoma es obligatorio
        </div>
    </div>-->

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="intProvincia">Provincia</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listProvincia"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdProvincia"
                                           [readonly]="!listProvincia || listProvincia.length === 0"
                                           [loading]="!listProvincia || listProvincia.length === 0"
                                           notFoundText="Provincia no encontrada"
                                           [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                           placeholder="-- Seleccione una Provincia --"
                                           clearAllText="Eliminar selección">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvincia','required')">
                                    Provincia es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpDireccion">Dirección</label>
                                <input formControlName="Direccion" name="Direccion" title=""
                                       class="form-control" id="inpDireccion" type="text" value="" [ngClass]="displayFieldCss('Direccion')" maxlength="180">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Direccion','required')">
                                    Dirección es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpLocalidad">Localidad</label>
                                <input formControlName="Localidad" name="Localidad" title=""
                                       class="form-control" id="inpLocalidad" type="text" value="" [ngClass]="displayFieldCss('Localidad')" maxlength="100">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Localidad','required')">
                                    Localidad es obligatoria
                                </div>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpCodigoPostal">Código Postal</label>
                                <input formControlName="CodigoPostal" name="CodigoPostal" title="" numbersOnly
                                       class="form-control" id="inpCodigoPostal" type="text" value="" [ngClass]="displayFieldCss('CodigoPostal')" maxlength="5">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostal','required')">
                                    Código Postal es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpTelefono">Telefono</label>
                                <input formControlName="Telefono" name="Telefono" title=""
                                       class="form-control" id="inpTelefono" type="text" value="" [ngClass]="displayFieldCss('Telefono')" maxlength="80">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Telefono','required')">
                                    Teléfono es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpEmail">Email</label>
                                <input formControlName="Email" name="Email" title=""
                                       class="form-control" id="inpEmail" type="text" [ngClass]="displayFieldCss('Email')" value="" maxlength="50">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','required')">
                                    Email es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','email')">
                                    Formato incorrecto
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpActivo">Activo</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="Activo" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                                                
                            </div>

                        </div>
                        
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpObservaciones">Observaciones</label>
                                <textarea style="resize:none" formControlName="Observaciones" name="Observaciones" title=""
                                          class="form-control" id="inpObservaciones" type="text" value="" maxlength="5000"></textarea>
                            </div>
                        </div>

                        <!--<div class="row">
                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpFecha">Fecha</label>
                                <p-calendar formControlName="Fecha" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('Fecha')"
                                            [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>
                        </div>-->

                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="usuarioAC.Id > 0">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <div class="card-header-buscador">
                        <i class="fa fa-plus"></i> <strong id="stAduana">Comunidades Autónomas Agente Control</strong>
                        <label class="col-form-label required-field" for="stCA"></label>
                    </div>
                    <div class="card-body-detalle-list">
                        <div class="row">
                            <div class="col-md-12">
                                <!--Tabla comunidades activas-->
                                <table *ngIf="comunidadesActivas.length > 0" class="table table-list table-responsive table-sm">
                                    <thead>
                                        <tr>
                                            <th class="cabecerasTablaDetalles"></th>
                                            <!--<th class="cabecerasTablaDetalles"></th>-->
                                            <th class="cabecerasTablaDetalles">Comunidad Autónoma</th>
                                            <th class="cabecerasTablaDetalles">Activo</th>
                                            <th class="cabecerasTablaDetalles">Fecha Activación Inicial</th>
                                            <th class="cabecerasTablaDetalles">Fecha Baja</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of comunidadesActivas">

                                            <td scope="col" class="col-md-1">
                                                <div class="btn-group">
                                                    <button type="button" (click)="onEditAgenteControlCa(item)" title="Editar Agente Control CA"
                                                            class="btn btn-sm btn-info">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                </div>

                                                <!--<div class="btn-group">
                                                    <button type="button" (click)="onDeleteAgenteControlCa(item)"
                                                            class="btn btn-sm btn-danger">
                                                        <i class="fa fa-remove"></i>
                                                    </button>
                                                </div>-->
                                            </td>

                                            <td scope="col" class="col-md-5">{{item.Descripcion}}</td>
                                            <td scope="col" class="col-md-1">{{item.ActivacionInicial | siNo}}</td>
                                            <td scope="col" class="col-md-2">{{item.FechaActivacionInicial | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                            <td scope="col" class="col-md-2">{{item.FechaBaja | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!--Tablas comunidades No activas-->
                                <table *ngIf="comunidadesNoActivas.length > 0" class="table table-list table-responsive table-sm">
                                    <thead>
                                        <tr>
                                            <th class="cabecerasTablaDetalles"></th>
                                            <!--<th class="cabecerasTablaDetalles"></th>-->
                                            <th class="cabecerasTablaDetalles">Comunidad Autónoma</th>
                                            <th class="cabecerasTablaDetalles">Activo</th>
                                            <th class="cabecerasTablaDetalles">Fecha Activación Inicial</th>
                                            <th class="cabecerasTablaDetalles">Fecha Baja</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of comunidadesNoActivas">

                                            <td scope="col" class="col-md-1">
                                                <div class="btn-group">
                                                    <button type="button" (click)="onEditAgenteControlCa(item)" title="Editar Agente Control CA"
                                                            class="btn btn-sm btn-info">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                </div>

                                                <!--<div class="btn-group">
                                                    <button type="button" (click)="onDeleteAgenteControlCa(item)"
                                                            class="btn btn-sm btn-danger">
                                                        <i class="fa fa-remove"></i>
                                                    </button>
                                                </div>-->
                                            </td>

                                            <td scope="col" class="col-md-5">{{item.Descripcion}}</td>
                                            <td scope="col" class="col-md-1">{{item.ActivacionInicial | siNo}}</td>
                                            <td scope="col" class="col-md-2">{{item.FechaActivacionInicial | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                            <td scope="col" class="col-md-2">{{item.FechaBaja | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
